import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, Form, Input, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { isPhoneNumber, isRequired } from "../fields/validator";
import Turnstile, { useTurnstile } from "react-turnstile";
import {
  resetStatus,
  selectAuth,
  signIn,
} from "../../redux/reducers/slice/auth";
import { ACCESS_TOKEN, ROUTER_PATH } from "../../common/constant";
import { useTranslation } from "react-i18next";
import { localizeRouteKey } from "../../shared/helpers";
import { setTitlePage } from "../../utils/helper";
import { NAME_AUTH } from "../wishButton/authModal";
import { actionLoadData } from "../../redux/reducers/slice/profile";
import { CLOUDFLARE_SITE_KEY } from "../../utils/constant";

const AuthSignIn = (props: any) => {
  const { type, setNameAuthModal, closeAuthModal } = props;
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [captchaToken, setCaptchaToken] = useState<string | null>("");
  const turnstile = useTurnstile();

  useEffect(() => {
    if (type !== "MODAL") {
      setTitlePage(t("title_page_sign_in"));
    }
    dispatch(resetStatus());
  }, []);

  useEffect((): any => {
    if (localStorage.getItem(ACCESS_TOKEN) !== null) {
      if (type === "MODAL") {
        // dispatch(getWishesList({ offset: 0, limit: 1000 }));
        dispatch(actionLoadData());
        closeAuthModal();
      } else {
        window.location.href = localizeRouteKey(ROUTER_PATH.HOME);
      }
    }
  });

  const handleSubmit = async (values: any) => {
    const query = {
      username: values.phoneNumber,
      password: values.password,
      token: captchaToken,
    };
    await dispatch(await signIn(query, onHandleErrorTurnstile));
  };

  const handleClickSignUp = () => {
    if (type === "MODAL") {
      setNameAuthModal(NAME_AUTH.signUp);
    } else {
      props.history.push(localizeRouteKey(ROUTER_PATH.SIGN_UP));
    }
  };

  const handleClickForgotPassword = () => {
    if (type === "MODAL") {
      setNameAuthModal(NAME_AUTH.forgotPassword);
    } else {
      props.history.push(localizeRouteKey(ROUTER_PATH.FORGOT_PASSWORD));
    }
  };

  const handleOnVerify = (token: string) => {
    setCaptchaToken(token);
  }

  const onHandleErrorTurnstile = (error: any) => {
    setCaptchaToken(null);
    turnstile?.reset();
  }

  return (
    <div>
      <div className="kd-sign-in-form-content center">
        <span className="kd-name-component">{t("title_screen_sign_in")}</span>
      </div>

      <Form
        className="kd-sign-in-form-content center content-auth-wrapper"
        size="large"
        name="loginForm"
        onFinish={(values) => handleSubmit(values)}>
        <Form.Item
          className="kd-sign-in-form-item"
          name="phoneNumber"
          rules={[isRequired, isPhoneNumber]}>
          <Input
            className="input"
            // placeholder={t("field_phone_number")}
            addonBefore={t("field_phone_number")}
          />
        </Form.Item>

        <Form.Item
          className="kd-sign-in-form-item"
          name="password"
          rules={[isRequired]}>
          <Input.Password
            className="input"
            // placeholder={t("field_password")}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            addonBefore={t("field_password")}
          />
        </Form.Item>
        <Turnstile
          sitekey={`${CLOUDFLARE_SITE_KEY}`}
          onSuccess={handleOnVerify}
          onError={onHandleErrorTurnstile}
          onExpire={onHandleErrorTurnstile}
          onTimeout={onHandleErrorTurnstile}
          theme="light"
          refreshExpired="auto"
        />

        <Form.Item noStyle>
          {auth.message !== t("point_status_success") ? (
            <span className="message">{auth.message}</span>
          ) : null}

          <div className="signin-forgot-pass-wrap">
            {auth.loading ? (
              <Spin size="large" />
            ) : (
              <Button
                  className="kd-sign-in-form-button kd-btn-primary-2"
                  loading={!captchaToken}
                  disabled={!captchaToken}
                  type="primary"
                  htmlType="submit">
                {t("btn_sign_in")}
              </Button>
            )}
            <div className="kd-sign-in-form-content forgot-pass-btn">
              <a onClick={handleClickForgotPassword}>{t("forgot_password")}?</a>
              {/* <Link to={localizeRouteKey(ROUTER_PATH.FORGOT_PASSWORD)}>
              </Link> */}
            </div>
          </div>
          <div className="kd-sign-in-form-content center mb-10 kd-sign-up-btn">
            <a aria-disabled onClick={handleClickSignUp}>{t("btn_sign_up")}</a>

            {/* <Link to={localizeRouteKey(ROUTER_PATH.SIGN_UP)}>
            </Link> */}
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AuthSignIn;
